export { ModernTabs } from './ModernTabs';
export { ModernTab } from './ModernTab/ModernTab';
